import {
    InsertDriveFile as DocumentFileIcon,
    Business as CompanyIcon,
    EventNote as DateIcon,
    Description as ProjectIcon,
} from "@mui/icons-material";

export function DocumentIcon() {
    return <DocumentFileIcon sx={{ color: "primary.main" }} />;
}

export function CompanyIconSmall() {
    return (
        <CompanyIcon fontSize="small" sx={{ mr: 0.5, color: "primary.main" }} />
    );
}

export function ProjectIconSmall() {
    return (
        <ProjectIcon fontSize="small" sx={{ mr: 0.5, color: "primary.main" }} />
    );
}

export function DateIconSmall() {
    return (
        <DateIcon fontSize="small" sx={{ mr: 0.5, color: "primary.main" }} />
    );
}

export function CompanyIconInput() {
    return (
        <CompanyIcon fontSize="small" sx={{ mr: 1, color: "primary.main" }} />
    );
}

export function ProjectIconInput() {
    return (
        <ProjectIcon fontSize="small" sx={{ mr: 1, color: "primary.main" }} />
    );
}

export function DateIconInput() {
    return <DateIcon fontSize="small" sx={{ mr: 1, color: "primary.main" }} />;
}
